// import { hpHttpClient } from 'root/api/http';
import { hpGqlClient } from 'root/api/';
import { crudActions } from 'root/store/helpers';
import { ShortcutQuery } from './query';

const { create, filter, fetchMany, getById, update, deleteById, upsert } = hpGqlClient.shortcut;

export const actions = {
  ...crudActions('shortcut', {
    create, filter, fetchMany, getById, update, deleteById, upsert
  }, {
    queries: ShortcutQuery,
  }),
};
